// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3rdZz","label":"Radio_label__syPGA","checkMark":"Radio_checkMark__2HVAC","disabled":"Radio_disabled__3pGoX"};